import {merchantSessionStorage} from "./merchant-state/MerchantStorage";
import {MERCHANT_STORAGE_KEYS} from "../Constants";
import {userDataModule} from "./UserDataModule";
import {executeWhenDocumentVisible} from "../../blinkpay/UtilsLib";
import {getMerchant} from "./PublicData";
import {sdkState} from "./SDKState";
import {walletModule} from "./WalletModule";
import {WidgetRoutes} from "../../blinkpay/widget/WidgetRoutes";

class OnboardingModule {
    init() {
        let onboardingFlow = merchantSessionStorage.getItem(MERCHANT_STORAGE_KEYS.onBoardingBehaviour);
        merchantSessionStorage.removeItem(MERCHANT_STORAGE_KEYS.onBoardingBehaviour);

        let removeHandler = null;

        userDataModule.authenticationChange.addListener(() => {
            if (userDataModule.isAuthenticated()) {
                if (onboardingFlow == null) {
                    // welcome flow has a lower priority than any other onboarding flow
                    onboardingFlow = "welcome";
                    merchantSessionStorage.setItem(MERCHANT_STORAGE_KEYS.onBoardingBehaviour, onboardingFlow);
                }
                if (removeHandler) {
                    removeHandler();
                }
                // Onboarding flows need the tab to be active.
                const currentOnboardingFlow = onboardingFlow;
                removeHandler = executeWhenDocumentVisible(() => {
                    if (currentOnboardingFlow === "welcome") {
                        if (userDataModule.userData.showOnboarding && getMerchant()?.allowPurchases && !sdkState.hideWallet) {
                            walletModule.changeRoute(WidgetRoutes.WELCOME);
                        }
                    }
                }).removeHandler;
                onboardingFlow = null;
                merchantSessionStorage.removeItem(MERCHANT_STORAGE_KEYS.onBoardingBehaviour);
            }
        });
    }
}

export const onboardingModule = new OnboardingModule();
